<template>
  <div id="app">
    <transition>
      <router-view></router-view>
    </transition>
  </div>
</template>

<script>
export default {
  name: "app"
};
</script>

<style>
#app {
  font-family: "MicrosoftYaHei", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}
html,
body,
section,div,p,a,ul,li {
  margin: 0;
  padding: 0;
}
ul,
ol {
  list-style: none outside none;
}
.searchStyle{width: 1000px;margin: 0 auto;}
.searchStyle .el-input .el-input__inner{
  width:500px;
  height: 60px;
  font-size: 16px;
}
.searchStyle .el-input-group__append, .el-input-group__prepend{
  width: 188px;
  text-align: center;
  color:#ffffff;
  background-color: #00477b;
  border-color:#00477b; 
  font-size: 16px;
}

.formStyle .el-input .el-input__inner{
  width:300px;
  height: 40px;
  font-size: 14px;
}
.formStyle .el-input-group__append, .el-input-group__prepend{
  width: 188px;
  text-align: center;
  color:#ffffff;
  background-color: #00477b;
  border-color:#00477b; 
  font-size: 12px;
}
.el-table{text-align: center;}
.el-table th{
  background: #efefef;
  color: #333333;
  height: 60px;
  font-family: 'microsoft yahei';
}
.textEllipsis{
width: 280px;
display: inline-block;
overflow: hidden;
white-space:nowrap; 
text-overflow:ellipsis;
}
</style>
